import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addRoleFields {
    name?: string,
    permissions?: number[]
}

// Add role state
export interface addRoleState {
    fields: addRoleFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddRoleState: addRoleState = {
    fields: {
        name: "",
        permissions: []
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const addRoleSlice = createSlice({
    name: 'add_role',
    initialState: initialAddRoleState,
    reducers: {
        init: state => initialAddRoleState,
        set: ( state, {payload}: PayloadAction<addRoleFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})